<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>
    <!-- <li class="breadcrumb-item">
      <a routerLink="/page/active-license">{{'Form.ActiveLicense'|translate}}</a>
    </li> -->
    <li class="breadcrumb-item active" aria-current="page">
      {{ "Left_Menu.Plan" | translate }}
    </li>
    <li
      style="position: absolute; right: 39px"
      placement="left"
      ngbTooltip="{{ 'Form.ADDPlan' | translate }}"
    >
      <div>
        <button
          style="padding: 3px"
          type="button"
          class="btn-shadow d-inline-flex align-items-center btn btn-primary px-2"
          (click)="open(content); licenseManagementId = null; onReset()"
        >
          <i class="fa fa-plus font-size-lg pt-1 text-white"></i>
        </button>
      </div>
    </li>
  </ol>
</nav>

<div class="main-card mb-3 card">
  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
    >
      <thead class="font-size-lg text-white">
        <tr>
          <th>{{ "Form.NAME" | translate }}</th>
          <th class="text-center">{{ "Form.DisplayName" | translate }}</th>
          <th class="text-center">{{ "Form.paymentFrequency" | translate }}</th>
          <th class="text-center">{{ "Form.amount" | translate }}</th>
          <th class="text-center">{{ "Form.applicableAmount" | translate }}</th>
          <th class="text-center">{{ "Form.taxAmount" | translate }}</th>
          <th class="text-center">{{ "Form.validFrom" | translate }}</th>
          <th class="text-center">{{ "Form.validUpto" | translate }}</th>
          <th class="text-center">{{ "Form.STATUS" | translate }}</th>
          <th class="text-center">{{ "Form.ACTIONS" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td>
            {{ item.name }}
          </td>
          <td class="text-center">{{ item.displayName }}</td>
          <td class="text-center">{{ item.paymentFrequency }}</td>
          <td class="text-center">{{ item.amount }}</td>
          <td class="text-center">{{ item.applicableAmount }}</td>
          <td class="text-center">{{ item.taxAmount }}</td>
          <td class="text-center">
            {{ item.validFrom | date : "dd MMM yyyy" }}
          </td>
          <td class="text-center">
            {{ item.validUpto | date : "dd MMM yyyy" }}
          </td>
          <td class="text-center">
            <mat-slide-toggle
              #darkModeSwitch
              [(ngModel)]="item.status"
              (change)="onStatusChange(item)"
              class="custom-toggle"
            >
            </mat-slide-toggle>
          </td>
          <td class="text-center">
            <span
              mat-icon-button
              style="cursor: pointer"
              [matMenuTriggerFor]="menu"
              class="actions-icon-btn pt-3 pb-1 px-2 bg-transparent"
            >
              <mat-icon
                class="mat-icon material-icons text-center ps-2 pt-2 btn-icon-only bg-transparent mat-icon-no-color"
                >more_vert</mat-icon
              >
            </span>

            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="open(content); toggleForm(item); currentLicense = item"
                class="text-center"
              >
                <span
                  class="bg-transparent"
                  matTooltip="{{ 'Form.EDIT' | translate }}"
                  matTooltipPosition="right"
                >
                  <i
                    class="fa fa-pencil-square-o text-primary font-size-lg"
                    aria-hidden="true"
                  ></i>
                </span>
              </button>
              <button
                mat-menu-item
                class="text-center"
                (click)="openDeleteConfirmationDialog(item.id)"
              >
                <span
                  class="bg-transparent"
                  matTooltip="{{ 'Form.DELETE' | translate }}"
                  matTooltipPosition="right"
                >
                  <i
                    class="fa fa-trash-o text-danger font-size-lg"
                    aria-hidden="true"
                  ></i>
                </span>
              </button>
            </mat-menu>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template
  #content
  let-modal
  class="main-card mb-3 col-md-6 col-xl-4 mx-auto card add-edit-user"
  style="width: 70% !important"
>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" *ngIf="licenseManagementId">
      {{ "Form.UpdatePlan" | translate }}
    </h4>
    <h4 class="modal-title" id="modal-basic-title" *ngIf="!licenseManagementId">
      {{ "Form.ADDPlan" | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="close"
      (click)="
        modal.dismiss('Cross click'); licenseManagementId = null; onReset()
      "
    >
      X
    </button>
  </div>
  <div class="modal-body">
    <div class="">
      <div class="card-body pt-0 ps-1">
        <form [formGroup]="form" class="needs-validation">
          <div class="position-relative row form-group mb-2">
            <label for="name_Id" class="col-sm-12 col-form-label"
              >{{ "Form.NAME" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="name"
                name="name"
                id="name_Id"
                placeholder="{{ 'Form.NAME' | translate }}"
                type="text"
                class="form-control"
                required
              />
              <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                <div *ngIf="f.name.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="displayName" class="col-sm-12 col-form-label"
              >{{ "Form.DisplayName" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="displayName"
                name="displayName"
                id="displayName"
                placeholder="{{ 'Form.DisplayName' | translate }}"
                type="text"
                class="form-control"
                required
              />
              <div
                *ngIf="submitted && f.displayName.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.displayName.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="paymentFrequency" class="col-sm-12 col-form-label"
              >{{ "Form.paymentFrequency" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <ng-select
                [items]="paymentFrequencyList"
                [virtualScroll]="true"
                bindLabel="label"
                bindValue="value"
                formControlName="paymentFrequency"
                placeholder="{{ 'Form.paymentFrequency' | translate }}"
              >
              </ng-select>
              <div
                *ngIf="submitted && f.paymentFrequency.errors"
                style="font-size: 80%; color: #e02b1d"
              >
                <div *ngIf="f.paymentFrequency.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="amount" class="col-sm-12 col-form-label"
              >{{ "Form.amount" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="amount"
                name="amount"
                id="amount"
                placeholder="{{ 'Form.amount' | translate }}"
                type="text"
                class="form-control"
                required
              />
              <div
                *ngIf="submitted && f.amount.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.amount.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
                <div *ngIf="f.amount.errors.maxLength">
                  {{ "Form.Error.AmountLength" | translate }}
                </div>
                <div *ngIf="f.amount.errors.pattern">
                  {{ "Form.Error.InavlidAmount" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="applicableAmount" class="col-sm-12 col-form-label"
              >{{ "Form.applicableAmount" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="applicableAmount"
                name="applicableAmount"
                id="applicableAmount"
                placeholder="{{ 'Form.applicableAmount' | translate }}"
                type="text"
                class="form-control"
                required
              />
              <div
                *ngIf="submitted && f.applicableAmount.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.applicableAmount.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
                <div *ngIf="f.applicableAmount.errors.maxLength">
                  {{ "Form.Error.AmountLength" | translate }}
                </div>
                <div *ngIf="f.applicableAmount.errors.pattern">
                  {{ "Form.Error.InavlidAmount" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="taxAmount" class="col-sm-12 col-form-label"
              >{{ "Form.taxAmount" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="taxAmount"
                name="taxAmount"
                id="taxAmount"
                placeholder="{{ 'Form.taxAmount' | translate }}"
                type="text"
                class="form-control"
                required
              />
              <div
                *ngIf="submitted && f.taxAmount.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.taxAmount.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
                <div *ngIf="f.taxAmount.errors.maxLength">
                  {{ "Form.Error.AmountLength" | translate }}
                </div>
                <div *ngIf="f.taxAmount.errors.pattern">
                  {{ "Form.Error.InavlidAmount" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="totalAmount" class="col-sm-12 col-form-label"
              >{{ "Form.totalAmount" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="totalAmount"
                name="totalAmount"
                id="totalAmount"
                placeholder="{{ 'Form.totalAmount' | translate }}"
                type="text"
                class="form-control"
                required
              />
              <div
                *ngIf="submitted && f.totalAmount.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.totalAmount.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
                <div *ngIf="f.totalAmount.errors.maxLength">
                  {{ "Form.Error.AmountLength" | translate }}
                </div>
                <div *ngIf="f.totalAmount.errors.pattern">
                  {{ "Form.Error.InavlidAmount" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="discount" class="col-sm-12 col-form-label"
              >{{ "Form.discount" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="discount"
                name="discount"
                id="discount"
                placeholder="{{ 'Form.discount' | translate }}"
                type="text"
                class="form-control"
                required
              />
              <div
                *ngIf="submitted && f.discount.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.discount.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
                <div *ngIf="f.discount.errors.maxLength">
                  {{ "Form.Error.AmountLength" | translate }}
                </div>
                <div *ngIf="f.discount.errors.pattern">
                  {{ "Form.Error.InavlidAmount" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="description" class="col-sm-12 col-form-label"
              >{{ "Form.DESCRIPTION" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <textarea
                formControlName="description"
                name="description"
                id="description"
                placeholder="{{ 'Form.DESCRIPTION' | translate }}"
                type="text"
                rows="4"
                class="form-control"
                required
              ></textarea>
              <div
                *ngIf="submitted && f.description.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.description.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="features" class="col-sm-12 col-form-label"
              >{{ "Form.features" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <ejs-richtexteditor
                class="m-2"
                min-height="10px !important"
                id="editor"
                [placeholder]="'Enter text here...'"
                formControlName="features"
                [toolbarSettings]="toolbarSettings"
              ></ejs-richtexteditor>
              <div
                *ngIf="submitted && f.features.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.features.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="validFrom" class="col-sm-12 col-form-label"
              >{{ "Form.validFrom" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="validFrom"
                name="validFrom"
                id="validFrom"
                placeholder="{{ 'Form.validFrom' | translate }}"
                type="date"
                class="form-control"
                required
              />
              <div
                *ngIf="submitted && f.validFrom.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.validFrom.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="validUpto" class="col-sm-12 col-form-label"
              >{{ "Form.validUpto" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="validUpto"
                name="validUpto"
                id="validUpto"
                placeholder="{{ 'Form.validUpto' | translate }}"
                type="date"
                class="form-control"
                required
              />
              <div
                *ngIf="submitted && f.validUpto.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.validUpto.errors.required">
                  {{ "Form.Error.Required" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="phone_id" class="col-sm-12 col-form-label">{{
              "Form.STATUS" | translate
            }}</label>
            <div class="col-sm-12">
              <mat-slide-toggle
                [(ngModel)]="state"
                [ngModelOptions]="{ standalone: true }"
                (change)="onChange($event.checked)"
                class="custom-toggle"
              >
                {{
                  state
                    ? ("Form.ENABLE" | translate)
                    : ("Form.DISABLE" | translate)
                }}
              </mat-slide-toggle>
              <!--  <bSwitch
                [(ngModel)]="state"
                [ngModelOptions]="{ standalone: true }"
                [switch-on-text]="'Form.ENABLE' | translate"
                [switch-off-text]="'Form.DISABLE' | translate"
                [switch-on-color]="'success'"
                [switch-off-color]="'danger'"
                (changeState)="onChange($event)"
              ></bSwitch> -->
            </div>
          </div>

          <div
            class="position-relative row form-check modal-footer text-center justify-content-center"
          >
            <div class="col-sm-10 offset-sm-2">
              <button
                class="btn btn-primary btn-lg px-5 font-size-lg"
                style="margin-right: 10px"
                type="submit"
                (click)="onSubmit()"
              >
                {{ "Form.SAVE" | translate }}
              </button>
              <button
                class="btn reset-btn btn-lg text-white font-size-lg"
                (click)="onReset(); modal.dismiss('Cross click')"
              >
                {{ "Form.CANCEL" | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>
